// Generated by scripts/build-ui-icons.mjs.
export { XCircle as default } from "../ui/glyphs-8";
